import { render, staticRenderFns } from "./MensagensAgendadas.vue?vue&type=template&id=c4e08dc0&scoped=true"
import script from "./MensagensAgendadas.vue?vue&type=script&lang=js"
export * from "./MensagensAgendadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e08dc0",
  null
  
)

export default component.exports